import { render } from "./TradePreviewModal.vue?vue&type=template&id=4f1ca591&scoped=true"
import script from "./TradePreviewModal.vue?vue&type=script&lang=ts"
export * from "./TradePreviewModal.vue?vue&type=script&lang=ts"

import "./TradePreviewModal.vue?vue&type=style&index=0&id=4f1ca591&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4f1ca591"

export default script